import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import ButtonPrimary from '@components/shared/buttons/ButtonPrimary/ButtonPrimary';

import InputTextAreaLabel from '@components/shared/forms/molecules/InputTextAreaLabel/InputTextAreaLabel';

import TrianglePattern from './svg/triangle-pattern.svg';
import Blobbo from './svg/blobbo.svg';
import RoomTypes from '../shared/RoomTypes/RoomTypes';
import CloseButton from '../shared/CloseButton/CloseButton';
import styles from './CreateProjectModal.module.scss';

interface ICreateBoardModalProps {
  busy: boolean;
  newProjectName: string;
  newProjectType: string;
  onClose: () => void;
  onCreate: () => void;
  setNewProjectName: (newProjectName: string) => void;
  setNewProjectType: (newProjectType: string) => void;
  presetRoomTypeId?: string | number;
}

const CreateProjectModal = ({
  busy,
  newProjectName,
  newProjectType,
  setNewProjectName,
  setNewProjectType,
  onClose,
  onCreate,
  presetRoomTypeId
}: ICreateBoardModalProps) => {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && newProjectName.length) {
      onCreate();
    }
  };

  useEffect(() => {
    if (presetRoomTypeId) {
      setNewProjectType(presetRoomTypeId.toString());
    }
  }, [presetRoomTypeId]);

  return (
    <Modal
      animation={false}
      data-test="m-create-project-modal"
      dialogClassName={ styles.ModalDialog }
      onHide={ onClose }
      show
    >
      <div className={ styles.Content }>
        <div className={ styles.MainContentWrapper }>
          <span className={ styles.TrianglePattern }>
            <TrianglePattern />
          </span>
          <span className={ styles.Blobbo }>
            <Blobbo />
          </span>

          <div className={ styles.CloseButton }>
            <CloseButton
              className={ styles.CloseButtonButton }
              onClick={ onClose }
            />
          </div>

          <div className={ styles.FormWrapper }>
            <h2 className={ styles.Header }>
              Your rad new project!
            </h2>

            <div className={ styles.NewProjectForm }>
              <InputTextAreaLabel
                autoFocus
                className={ styles.NewProjectNameInputText }
                disabled={ busy }
                onChange={ (e) => setNewProjectName(e.target.value) }
                onKeyPress={ handleKeyPress }
                placeholder="Name your awesome project"
                rows={1}
                title="Project Name"
                value={ newProjectName }
              />
              <RoomTypes
                roomTypeId={ Number(newProjectType) }
                onRoomTypeSelect={ (id) => setNewProjectType(id) }
              />
            </div>

            <div className={styles.Save}>
              <ButtonPrimary
                disabled={ !newProjectName.length || busy }
                onClick={ onCreate }
              >
                Let&rsquo;s get this baby started
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateProjectModal;
